<template>
  <div class='image-block'>
    <a :class='["settings"]' href='#' data-tip='Image settings' @click.prevent='onEdit'>
      <ion-icon name="settings"></ion-icon>
    </a>
    <transition v-on:before-appear="beforeEnter" name="fade" appear>
      <div 
          v-if='content.src'
          data-appear="250"
      >
          <span
          v-show="showImage"
        >
          <img :src='content.src' :alt='altText'/>
        </span>
      </div>
      <div v-else>
        <a class='select-image' @click.prevent='selectImage'>Choose image</a>
      </div>
    </transition>
  </div>
</template>
<script>
export default {
  props: {
    src: {type: String, default: null},
    altText: 'Placeholder image',
    editable: {type: Boolean, default: false},
    config: {type: Object, default: () => {}}
  },
  data () {
    return {
      content: {},
      showImage: true
    }
  },
  methods: {
    beforeEnter: function(el, done) {
      Velocity(
        el,
        { opacity: 0, translateY: "100%", translateZ: 0 },
        { duration: 0 }
      );
      const delay = Number(el.dataset.appear);
      setTimeout(function() {
        Velocity(
          el,
          { opacity: 1, translateY: "0%", translateZ: 0 },
          { complete: done, duration: 500 }
        );
      }, delay);
    },
    selectImage () {
      this.$eventBus.$emit('openMedia', {target: this})
    },
    updateValue (url) {
      this.content.src = url
      this.$emit('change', this.content)
    },
    onEdit () {
      let editable = [
        {name: "backgroundcolor", label:'Background Color', type: "color", model: 'options.backgroundColor'},
        {name: "color", label:'Text Color', type: "color", model: 'options.textColor'}
      ]
      let fields = [
        {
          title: "Colours",
          classes: 'grid colours',
          fields: editable
        }
      ]
      this.$emit('edit', {fields, editorConfig: {title: 'Image block', onDelete: this.onDelete}, editorClass:'BlockEditPanel'})
    },
    onDelete () {
      this.$emit('delete', this)
    },
    mounted() {
      this.animateIn("showImage", 1000);
    },
  },
  created () {
    this.content = this.config
    this.animateIn = (target, delay) => {
        setTimeout(() => Vue.set(this, target, true), delay);
      };
  }
}
</script>
<style scoped lang='scss'>
  .image-block {
    position: relative;
    img {
      width: 100%;
    }
    a.settings {
      position: absolute;
      top: 10px;
      left: 10px;
    }
    a.select-image {
      display: block;
      text-align: center;
      border: 1px solid #ccc;
      background-color: #efefef;
      color: #333;
      padding: 10px;
      cursor: pointer;
      border-radius: 5px;
    }
  }
</style>